import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Button } from '@3plearning/react-components';
import { defaultTheme, QtcRendererProvider } from '@3plearning/question-components-library';
import { ChakraProvider, mergeThemeOverride } from '@chakra-ui/react';
import { ModalBody, Header, Content, Footer } from './styled';
import { dismissModal } from '../../containers/modal-manager/modal-manager-actions';
import SvgIcon from '../svg-icon/svg-icon';
import { BackArrow } from '../../helpers/icon-dictionary';
import Conquest from '../conquest/conquest';
import mleTheme from '../../helpers/mle-theme';

function PreviewModal({ previewInfo, i18n }) {
  const { domain, question, girlId, showBackButtons } = previewInfo;
  const dispatch = useDispatch();

  const closePreviewModal = () => {
    dispatch(dismissModal());
  };

  return (
    <ModalBody>
      <Header>
        {showBackButtons && <SvgIcon icon={BackArrow} onClick={closePreviewModal} />}
        <span>{domain}</span><span className="pipe">|</span><span>{question}</span>
      </Header>
      <Content>
        <ChakraProvider theme={mergeThemeOverride(defaultTheme, mleTheme)}>
          <QtcRendererProvider>
            <Conquest girlId={girlId} />
          </QtcRendererProvider>
        </ChakraProvider>
      </Content>
      {showBackButtons &&
        <Footer>
          <Button
            onClick={closePreviewModal}
            primary
            text={i18n.t`Back`}
            type={Button.LOZENGE}
          />
        </Footer>
      }
    </ModalBody>
  );
}

export function createPreviewModal({ previewInfo, i18n }) {
  return {
    content: <PreviewModal previewInfo={previewInfo} i18n={i18n} />,
    id: 2,
    buttons: [],
    className: 'question-preview-modal',
    noCloseButton: previewInfo.showBackButtons
  };
}

PreviewModal.propTypes = {
  previewInfo: PropTypes.object,
  i18n: PropTypes.object
};

export default PreviewModal;

